import React from 'react';
import AlertIcon from '../../_styles/images/AlertIcon.png';
import Callable from '../../shared/Callable';
import { connect } from 'react-redux';
import ArrowLeft from '../../_styles/images/ArrowLeft.png';
import { Link } from 'react-router-dom';
import analyticsService from '../../shared/analytics/analytics-service';

function FedmilPageProrated(props) {
    function addSecondaryCard() {
        analyticsService.analyticsProcessEvent({
            "event": "click_generic",
            "context": {
              "event_action": "add secondary card"
            }
          });
        props.history.push('/JoinCommute/add-payment/backup')
    }

    function changeStartDate() {
        analyticsService.analyticsProcessEvent({
            "event": "click_generic",
            "context": {
              "event_action": "change start date"
            }
          });
        props.history.push('/JoinCommute/add-payment/change-start-date')
    }
    return (
        <div className='fedmil-container'>

            <div className="main-container">
                <div className='green-header'>
                    <div className='backArrow'>
                        <Link className="overview-link" onClick={props.history.goBack}>
                            <img alt='go back' src={ArrowLeft}></img>
                        </Link>
                    </div>
                </div>
                <div className='main-content'>
                    <div className='header'>
                        <div className='alert-image'>
                            <img src={AlertIcon} alt='alert' />
                        </div>
                        <div className='heading'>
                            {
                                    "Your benefit card won’t cover your first prorated payment"
                            }
                        </div>
                    </div>
                    <div className='fedmil-content'>
                        <div className='content'>
                            <div className='first-section'>
                                {
                                    (!props.selectedVan?.isPredelivery && !props.savedCards[0]?.isCommuter) ?

                                         "To proceed you can either change your start date to when your benefit card will have sufficient funds, or you can add a secondary payment card to cover the first month's cost."
                                     :
                                         "To proceed you can add a secondary payment card to cover the first month’s cost."
                                }
                            </div>
                        </div>
                        <div className="pre-text">
                            If you need help, please call <Callable className="greentext" phone="800 VAN 4 WORK" />
                        </div>
                    </div>
                    <div className='button-container'>
                        {/* <button tabIndex={0}  className={` ${props.summaryData?.isRetailRequiredForRecurringPayment ? 'primarySecondaryCard' : 'secondaryCard'}`} onClick={addSecondaryCard}>Add Secondary Card</button> */}
                        {/* <button tabIndex={0}  className="secondaryCard" onClick={addSecondaryCard}>Add Secondary Card</button> */}
                        {
                            (props.selectedVan?.isPredelivery || (props.savedCards[0] && props.savedCards[0].isCommuter)) &&
                            <button tabIndex={0} className="primarySecondaryCard" onClick={addSecondaryCard}>Add Secondary Card</button>
                        }
                        {
                            !props.selectedVan?.isPredelivery && !props.savedCards[0]?.isCommuter &&
                            <button tabIndex={0} className="secondaryCard" onClick={addSecondaryCard}>Add Secondary Card</button>
                        }

                        {
                            ( !props.selectedVan?.isPredelivery && !(props.savedCards[0] && props.savedCards[0].isCommuter)) &&
                            <button tabIndex={0} className="startdate" onClick={changeStartDate}>Change Start Date</button>
                        }

                    </div>
                </div>


            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        joinCommuteData: state.joinCommute,
        selectedVan: state.joinCommute.selectedVan,
        summaryData: state.joinCommute.userCommuteData.summaryData,
        savedCards: state.joinCommute.payment.cards
    }
}

export default connect(mapStateToProps, null)(FedmilPageProrated)